import { render, staticRenderFns } from "./AdviserBenefitCard.vue?vue&type=template&id=a1602b80&scoped=true"
import script from "./AdviserBenefitCard.vue?vue&type=script&lang=js"
export * from "./AdviserBenefitCard.vue?vue&type=script&lang=js"
import style0 from "./AdviserBenefitCard.vue?vue&type=style&index=0&id=a1602b80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1602b80",
  null
  
)

export default component.exports